import React from 'react';
import Layout from '../../components/Layout';
import Section from '../../components/Section';
import Head from '../../components/head';
import OpenGraphTitle from '../../components/OpenGraphTitle';
import OpenGraphDescription from '../../components/OpenGraphDescription';
import { FranchiseeProvider } from '../../context/Franchisee';
import { useFranchiseeContext } from '../../context/Franchisee';
import { GetStaticPaths, GetStaticProps } from 'next';
import Gataware from '../../SDKs/Gataware';
import camelcaseKeys from 'camelcase-keys';
import Link from 'next/link';
import { Duration } from 'luxon';
import { FranchiseeState } from '../../context/Franchisee/franchisee.types';

export const getStaticPaths: GetStaticPaths = async () => {
    // const response = await Gataware.getLocations()
    //   .then(({ data }) => JSON.parse(data))
    //   .then((data) => data.data.map((franchisee) => camelcaseKeys(franchisee)));
  
    // const paths = response.map(({ slug }) => ({ params: { franchiseeSlug: slug } }));
    const popularStores: Array<string> = ['fort-worth'];
    const paths = popularStores.map((storeSlug) => ({
      params: { franchiseeSlug: storeSlug },
    }));
  
    return {
      paths,
      fallback: 'blocking',
    };
  };
  
  export const getStaticProps: GetStaticProps = async ({ params }) => {
    const { franchiseeSlug } = params;
  
    // const testResponse = await axios
    //   .post('/api/get-locations', { slugs: [franchiseeSlug.toLocaleString()] })
    //   .then((res) => {
    //     console.log(res);
    //   });
  
    // console.log(testResponse);
  
    const response = await Gataware.getLocations({
      slugs: [franchiseeSlug.toLocaleString()],
    }).then(({ data }) => JSON.parse(data));
  
    const franchisees = await response.data
      .filter(({ slug }) => franchiseeSlug === slug)
      .map((franchisee) => camelcaseKeys(franchisee));
  
    if (!franchisees.length) {
      return {
        notFound: true,
        revalidate: 28800,
      };
    }
  
    const [franchisee] = franchisees;
  
    let { aboutUsData, contactUsData } = franchisee;
    if (aboutUsData !== null && Object.keys(aboutUsData).length) {
      aboutUsData = camelcaseKeys(aboutUsData);
    }
    if (contactUsData !== null && Object.keys(contactUsData).length) {
      contactUsData = camelcaseKeys(contactUsData);
    }
  
    return {
      props: {
        franchisee,
        aboutUsData: aboutUsData || null,
        contactUsData: contactUsData || null,
      },
      revalidate: Duration.fromObject({ hours: 8 }).as('seconds'),
    };
  };
  
  interface CareersPageProps {
    /* add about page props here */
    franchisee: FranchiseeState;
  }

const Careers: React.FC<CareersPageProps> = ({franchisee}: CareersPageProps) => {
    return (
        <FranchiseeProvider franchiseeValue={franchisee}>
            <Layout alternateFooter>
            <Head
                slug='careers'
                title='Careers | Two Maids'
                description='Build a future with us by starting a career with Two Maids.'
            />
            <OpenGraphTitle title='Careers | Two Maids' />
            <OpenGraphDescription>
                Build a future with us by starting a career with Two Maids.
            </OpenGraphDescription>
            <div className='top-background-dots'></div>
                <div className='careers-container'>
                <div className='careers-hero-image-container'>
                    <img
                        src='https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1681921098/hubsite-reskin/TwoMaidsKitchen.webp'
                        alt='Two Maids Careers'
                    />
                </div>
                <>
                    <Section xs={12} md={12} lg={12}>
                        <h1 className='careers-heading'>Powered By Caring</h1>
                        <p className='careers-columns'>
                            It’s quite simple. Our people are the most powerful asset we have. Period. We know that they are the most important link in caring for our clients, 
                            and that’s why we take care of them. That means at Two Maids it’s never you working for us. It’s us working together to create a company we can be proud of while offering best-in-category 
                            services to our customers. Being powered by caring means that we’re working hard to create a culture where you feel appreciated and given the tools you need to succeed in work and life. 
                            Are you ready to work with us? We can’t wait to work with you.
                        </p>
                    </Section>
                    <div className='careers-maid-image-container'>
                        <img
                            src='https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1681931611/hubsite-reskin/maid-clear-bg.webp'
                            alt='Two Maids Careers'
                        />
                        <div className='grey-bg'></div>
                    </div>
                    <Section xs={12} md={12} lg={12}>
                        <div className='careers-future-section'>
                            <div>
                                <h2 className='careers-sub-heading'>Building a Future with Us</h2>
                                <p>Good people are the backbone of our brand, so we are committed to creating a work culture that makes you feel appreciated and part of something bigger. We want you to grow. We want you to thrive. And we want your feedback to help us continually improve. Here’s what else Two Maids offers:</p>
                            </div>
                            <div className='careers-button-section'>
                                <div className='careers-button-border'>
                                <Link href={franchisee.careerOpportunities} passHref><a target='_blank' className='careers-button'>Ready to work with us?</a></Link>
                                </div>
                                <p>Search for openings in your area</p>
                            </div>
                        </div>
                    <ul className='careers-benefits-list'>
                        <li>No nights. No weekends. No major holidays!</li>
                        <li>Competitive pay driven by your performance</li>
                        <li>Flexible hours</li>
                        <li>Training and support</li>
                        <li>Financial literacy training</li>
                        <li>Career advice and growth</li>
                        <li>A family-oriented work environment</li>
                        <li>Employer-sponsored benefits</li>
                        <li>Mileage reimbursement</li>
                    </ul>
                    <div className='careers-grey-section'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682368766/hubsite-reskin/cleaning_for_a_reason.webp" alt="Cleaning for a Reason Logo" />
                        <p>We believe in giving back. When you join the Two Maids team, you can participate in Cleaning for a Reason, where we provide free home cleanings to anyone undergoing cancer treatment. Our growth and success allow us to offer opportunities to Two Maids Teammates who want to put the power of caring to work in their community.</p>
                    </div>
                    <div className='careers-grey-section'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682368766/hubsite-reskin/alliance_for_hope.webp" alt="Alliance for Hope Logo" />
                        <p>We’re proud to announce our support of Alliance for Hope, a social change organization focused on creating hope-centered approaches to meet the needs of survivors of domestic violence, sexual assault, child abuse, elder abuse, and human trafficking. Every year, they help an average of 150,000 survivors of domestic violence and sexual assault and their children each year in the United States.</p>
                    </div>
                    </Section>
                    {/* <div className='careers-video-section'>
                        <div className='careers-video career-vid-one'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682369770/hubsite-reskin/play_button.webp" alt="Video play button" />
                        <div className='career-vid-gradient'></div>
                        <p>Meet Jodie, a Single Mom</p>
                        </div>
                        <div className='careers-video career-vid-two'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682369770/hubsite-reskin/play_button.webp" alt="Video play button" />
                        <div className='career-vid-gradient'></div>
                        <p>See How Claudia Crushes It</p>
                        </div>
                        <div className='careers-video career-vid-three'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682369770/hubsite-reskin/play_button.webp" alt="Video play button" />
                        <div className='career-vid-gradient'></div>
                        <p>Gloria Cleans for Good</p>
                        </div>
                        <div className='careers-video career-vid-four'>
                        <img src="https://res.cloudinary.com/twomaidsengi/image/upload/q_auto/v1682369770/hubsite-reskin/play_button.webp" alt="Video play button" />
                        <div className='career-vid-gradient'></div>
                        <p>Let Life Shine!</p>
                        </div>
                    </div> */}
                </>
                </div>
            </Layout>
        </FranchiseeProvider>
)};

export default Careers;
